module.exports = __webpack_public_path__ + "static/media/YB5M16_5.9d901ed4.jpg";